
import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-map",
  templateUrl: "./map.component.html",
  styleUrls: ["./map.component.scss"],
})
export class MapComponent implements OnInit {
  @Input() latitude = 48.8575;
  @Input() longitude = 2.3514;
  zoom = 15;

  center = { lat: this.latitude, lng: this.longitude };
  markerPosition = { lat: this.latitude, lng: this.longitude };
  constructor(){}

  ngOnInit() {

  }

}
